import ContentComponentHr from './ContentComponentHr';
import ContentComponentButton from './ContentComponentButton';
import ContentComponentImage from './ContentComponentImage';
import ContentComponentGalleryImage from './ContentComponentGalleryImage';
import ContentComponentText from './ContentComponentText';
import ContentComponentTitle from './ContentComponentTitle';
import ContentComponentSubtitle from './ContentComponentSubtitle';
import ContentComponentHtml from './ContentComponentHtml';
import ContentComponentGoogleMaps from './ContentComponentGoogleMaps';
import ContentComponentSliderImage from './ContentComponentSliderImage';
import ContentComponentVideo from './ContentComponentVideo';
import ContentComponentDynamic from './ContentComponentDynamic';

const ContentComponents = {
  button: ContentComponentButton,
  buttonSecondary: ContentComponentButton,
  galleryImage: ContentComponentGalleryImage,
  googleMaps: ContentComponentGoogleMaps,
  hr: ContentComponentHr,
  html: ContentComponentHtml,
  image: ContentComponentImage,
  sliderImage: ContentComponentSliderImage,
  subtitle: ContentComponentSubtitle,
  text: ContentComponentText,
  title: ContentComponentTitle,
  video: ContentComponentVideo,
  dynamic: ContentComponentDynamic,
};

export { ContentComponents as default };



// WEBPACK FOOTER //
// ./src/components/Content/ContentComponents/index.js